import Vue from 'vue'
import router from '@/router'
import store from '@/store'
import TourPlugin from './tour'

/**
 * Registra todos los plugins de la aplicación
 */
export default function registerPlugins () {
  // Registrar el plugin Tour
  Vue.use(TourPlugin, {
    store, // Importante: pasar el store explícitamente
    vuex: true,
    registerComponents: true,
  })

  // Aquí se pueden registrar otros plugins
}
